import { z } from 'zod';

export const searchResultItemSchema = z.object({
  id: z.string(),
  type: z.enum(['task', 'patient', 'email', 'provider', 'document', 'entity']),
  title: z.string(),
  subtitle: z.string(),
  status: z.string().optional(),
  priority: z.string().optional(),
});

export type SearchResultItem = z.infer<typeof searchResultItemSchema>;

export const searchResultsSchema = z.object({
  tasks: z.array(searchResultItemSchema),
  patients: z.array(searchResultItemSchema),
  emails: z.array(searchResultItemSchema),
  providers: z.array(searchResultItemSchema),
  documents: z.array(searchResultItemSchema),
  entities: z.array(searchResultItemSchema),
});

export type SearchResults = z.infer<typeof searchResultsSchema>;

export const searchRequestSchema = z.object({
  query: z.string().min(2).max(200),
});

export type SearchRequest = z.infer<typeof searchRequestSchema>;
